import React from "react";

import {m} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {useOfferRankingListBreadcrumbs} from "../../hooks/use_offer_ranking_breadcrumbs";

export const OfferRankingBreadcrumbs = () => {
    const breadcrumbs = useOfferRankingListBreadcrumbs();

    return (
        <div css={m(2, 0)}>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                {breadcrumbs.map((breadcrumb, index) => (
                    <BreadcrumbsItem {...breadcrumb} key={breadcrumb.key} isLinkingToCurrentLocation={index === breadcrumbs.length - 1} />
                ))}
            </Breadcrumbs>
        </div>
    );
};
import React from "react";

import {m} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../../app/components/breadcrumbs/BreadcrumbsItem";
import {useOfferRankingListBreadcrumbs} from "../../hooks/use_offer_ranking_breadcrumbs";

export const OfferRankingBreadcrumbs = () => {
    const breadcrumbs = useOfferRankingListBreadcrumbs();

    return (
        <div css={m(2, 0)}>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                {breadcrumbs.map((breadcrumb, index) => (
                    <BreadcrumbsItem {...breadcrumb} key={breadcrumb.key} isLinkingToCurrentLocation={index === breadcrumbs.length - 1} />
                ))}
            </Breadcrumbs>
        </div>
    );
};
